import {Tooltip} from "./Tooltip";

/**
 * Interface para descrever um campo do formulário.
 */

type ConditionOperators = "===" | "!==" | ">=" | "<=" | ">" | "<";

export const operations: Record<ConditionOperators, (a: any, b: any) => boolean> = {
    '===': (a, b) => a === b,
    '!==': (a, b) => a !== b,
    '>': (a, b) => typeof a === "number" && typeof b === "number" && a > b,
    '<': (a, b) => typeof a === "number" && typeof b === "number" && a < b,
    '>=': (a, b) => typeof a === "number" && typeof b === "number" && a >= b,
    '<=': (a, b) => typeof a === "number" && typeof b === "number" && a <= b
};

export interface Field {
    type: string; // Tipo do campo (ex.: "text", "select", "checkbox", etc.)
    label: string; // Rótulo do campo
    name?: string; // Nome do campo (usado para identificar o input)
    icon?: string; // Ícone associado ao campo
    tooltip?: Tooltip; // Tooltip adicional para exibir informações extras
    placeholder?: string; // Placeholder do campo (ex.: "Digite seu nome")
    defaultValue?: string; // Valor padrão para dropdown ou outros campos
    options?: { value: string; label: string }[]; // Opções para campos como select, radio, etc.
    className?: string; // Classe CSS personalizada para o campo
    layout?: string; // Layout CSS do campo (para grid, alinhamento, etc.)
    condition?: { field: string; value: any, operator?: ConditionOperators } | {
        field: string;
        value: any,
        operator?: ConditionOperators
    }[]; // Condições para exibir o campo
    conditionsAnd?: { field: string; value: any, operator?: ConditionOperators }[]; // Condições para exibir o campo
    populate?: {
        field: string;
        callback: (value: any) => { value: string; label: string }[];
    }; // Função para popular dinamicamente o campo (ex.: select com base em outro campo)
    collapsible?: { // Indica se o campo (ou seção) pode ser colapsável
        collapsed: boolean;
    };
    error?: boolean; // Indica se há um erro no campo
    hide?: boolean; // Indica se o campo deve ser ocultado
    half?: boolean;
    full?: boolean;
    value?: string;
    group_fields?: Array<Field>;
    clinicName?: string;
    latField?: string;
    lonField?: string;
    step?: string | number;
    max?: string | number;
    clearWhenHidden?: boolean;
    titleLevel?: 'h4' | 'h5'; // Nível do heading para campos do tipo "title". Por omissão: h5
}
